var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroissant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.43 10.43C18.7 2.16 23.14 2.48 25.53 4.87C27.91 7.25 42.7 28.23 39.6 31.33C38.57 32.36 36.34 32.2 34.27 34.27",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.72 4.2C29.21 2.66 42.98 -1.47 44.37 5.11C44.44 5.43 44.52 5.77 44.59 6.11C45.84 11.64 48.06 18.96 48.18 23.12C48.23 24.89 47.91 26.08 46.98 26.32C45.22 26.8 42.16 27.18 39.53 27.59",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.59 6.11C48.21 6.71 63.36 9.37 63.36 19.78C63.36 27.53 53.9 20.44 48.18 23.12",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.43 10.43C2.16 18.7 2.48 23.14 4.87 25.53C7.25 27.92 28.23 42.7 31.33 39.6C32.36 38.57 32.2 36.34 34.27 34.28",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.59 39.53C27.18 42.15 26.79 45.22 26.32 46.98C26.07 47.91 24.88 48.23 23.12 48.18C18.97 48.06 11.64 45.83 6.11001 44.58C5.77001 44.51 5.43001 44.44 5.11001 44.36C-1.46999 42.97 2.66001 29.2 4.20001 24.71",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.12 48.18C20.44 53.89 27.53 63.36 19.78 63.36C9.37999 63.36 6.70999 48.2 6.10999 44.59",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.86,
    height: 64.86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroissant);
export default __webpack_public_path__ + "static/media/croissant.72342375bf4064565ec65422e2554864.svg";
export { ForwardRef as ReactComponent };